'use client'

import { type FC, type PropsWithChildren } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import {
  LoginRegistrationUserLoginContent,
  LoginRegistrationUserLoginStateProvider,
} from '../../../login-registration'
import { urlResolverGetRedPointsNx } from '../../../url-handling'

export const StoryblokRedPointsLoginContent: FC<PropsWithChildren> = ({
  children,
}) => {
  const config = useGlobalConfigContext()

  return (
    <div className="my-2 bg-light-brand-medium shadow-m tablet:w-3/5 tablet:rounded-m">
      <LoginRegistrationUserLoginStateProvider>
        <div className="flex-1 basis-1/2 p-5 tablet:mb-6 tablet:ml-6 tablet:mr-3 tablet:rounded-m tablet:px-5">
          <LoginRegistrationUserLoginContent
            afterLoggedIn={() => {
              location.replace(urlResolverGetRedPointsNx(config))
            }}
          />
        </div>
      </LoginRegistrationUserLoginStateProvider>
      {children}
    </div>
  )
}
